import { render, staticRenderFns } from "./TheCompany.vue?vue&type=template&id=cfc8a4fc&scoped=true"
import script from "./TheCompany.vue?vue&type=script&lang=js"
export * from "./TheCompany.vue?vue&type=script&lang=js"
import style0 from "./TheCompany.vue?vue&type=style&index=0&id=cfc8a4fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc8a4fc",
  null
  
)

export default component.exports